// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"z4-z","displaySixCardTiles":"A4-z"};